import axios from './_nestAxios'

export const self = {
  obtenerInfoPersonal: () => axios.get('/usuarios/self/info-personal'),
  actualizarInfoPersonal: data => axios.put('/usuarios/self/actualizar-informacion-personal', data),
  actualizarContrasena: data => axios.put('/usuarios/self/actualizar-contrasena', data)
}

export const getSelect = () => axios.get('/usuarios', { params: { tipoConsulta: 'select' } })

export const obtenerxIdAsEdicion = id => axios.get(`/usuarios/${id}`)

export const nuevo = data => axios.post(`/usuarios`, data)

export const actualizarxId = (id, data) => axios.put(`/usuarios/${id}`, data)

export const cambiarContrasenia = (id, data) => axios.put(`/usuarios/${id}/actualizar-contrasena`, data)

export const eliminarxId = id => axios.delete(`/usuarios/${id}`)


// ============================ TÍTULOS VIÁTICOS ============================

export const obtenerxIdAsSlimInfo = (id) => {
  return axios.get(`/usuarios/info-slim/${id}`)
}

// Alias para compatibilidad (algunos módulos lo llaman "obtenerxIdAsInfoSlim")
export const obtenerxIdAsInfoSlim = obtenerxIdAsSlimInfo

  
export const obtenerTitulosViaticosxIdUsuarioAsSelect = idUsuario =>
  axios.get('/usuarios/titulos-viaticos', {
    params: {
      tipoConsulta: 'select',
      idUsuario: idUsuario
    }
  })
  
// ============================ TRABAJADORES ============================


export const nuevoTrabajador = data =>  axios.post('/usuarios/trabajadores', data);

export const obtenerTrabajadorIdNombresApellidos = () =>
  axios.get('/usuarios/self/id-nombres-apellidos');

export const obtenerNombreCompleto = () => axios.get(`/usuarios/self/info-personal`)

export const obtenerxTrabajadoresxCompaniaxBusquedaxTipoAsSelect2 = ({ busqueda }) =>
  axios.get('/usuarios', {
    params: {
      tipoConsulta: 'select2-trabajadores',
      busqueda
    }
  })
// ============================ USUARIOS (SELECT2) ============================

export const obtenerUsuariosTodosxBusquedaAsSelect2 = ({ busqueda }) =>
  axios.get('/usuarios', {
    params: {
      tipoConsulta: 'select2-todos',
      busqueda
    }
  })

  export const obtenerSoloId = () => axios.get('/usuarios/self/id')

  export const obtenerUsuariosContabilidadxBusquedaAsSelect2 = ({ busqueda }) => {
    return axios.get('/usuarios', {
      params: {
        tipoConsulta: 'select2-trabajadores',
        busqueda
      }
    })
  }

export const obtenerUsuarioSelfIdNombresApellidos = () => {
  return axios.get('/usuarios/self/id-nombres-apellidos')
}

// ============================ TÍTULOS VIÁTICOS (USUARIOS) ============================

export const nuevoTituloViatico = data => {
  return axios.post('/usuarios/titulos-viaticos', data)
}

export const actualizarTituloViaticoxId = (id, data) => {
  return axios.put(`/usuarios/titulos-viaticos/${id}`, data)
}

export const obtenerTituloViaticoxIdAsEdicion = id => {
  return axios.get(`/usuarios/titulos-viaticos/${id}`)
}

export const eliminarTituloViaticoxId = id => {
  return axios.delete(`/usuarios/titulos-viaticos/${id}`)
}

export const obtenerTitulosViaticosxUsuario = () => {
  // ✅ El backend obtiene el usuario autenticado desde el token (no requiere idUsuario)
  return axios.get('/usuarios/titulos-viaticos')
}